module.exports = __webpack_public_path__ + "static/media/put.5e78ba8f.wav";